import { makeAutoObservable, toJS } from "mobx";
import apiClient from "../api";
import AuthStore from "./AuthStore";
import UserStore from "./UserStore";
import { makePersistable } from "mobx-persist-store";
import { getCookie } from "../utils/cookie";
import { isHydrated } from "mobx-persist-store";
import { customStorage } from "../utils/customStorage";
import {
  benchMarkData,
  customBenchMark,
  customData,
  derivativeFilter,
  derivativeProfile,
  derivativeProfileDetails,
  events,
  getAssetClasses,
  getAssetClassesClient,
  getCustomExcel,
  getDataPerAsset,
  getDataPerAssetClient,
  getIndex,
  getTransaction,
  getTransactionDetails,
  performanceDuration,
  perVehicle,
  perVehicleClient,
  secondPageData,
  secPageReturns,
  submitEvents,
} from "../api/hooks/performance";
import {
  exportExcel,
  getAssetInternalTabs,
  getCurrentDate,
  getDateString,
  getDateStrPerformance,
  getPrintDate,
  performanceExcelData2,
  performanceOverallExcelStyle,
} from "../utils/functions";
import { derivativeTabs } from "../utils/data";

class PerformanceStore {
  selectedEvent = {
    eventName: "Event not selected",
    id: null,
  };
  eventsApiStatus = "";
  eventsData = [];
  timePeriod = {
    value: "notSelected",
    isSelected: true,
  };
  fromDateStore = {
    date: "",
    month: "",
    year: "",
  };
  toDateStore = {
    date: "",
    month: "",
    year: "",
  };
  isAssetClassClicked = false;
  selectedFirstRef = "";
  isSelectedPresent = true;
  selectedRefs = "null";
  derivativeRef = "";
  mainRef = null;
  isSecondPagePresent = false;
  isFilterApplied = false;
  isDateFilterApplied = false;
  currentAppliedFilter = "notSelected";
  selectedAssetClass = { id: "all", name: "Overall" };
  selectedDuration = "";
  selectedIndex = "";
  selectedIndexForApi = "";
  indexes = null;
  assetClasses = [];
  monthwiseData = {};
  subTabs = [];
  firstPageTable = [];
  dropdownData = {};
  secondPageTitle = "";

  secondPageNormalData = [];
  secondPageRememberedNormalData = [];

  secondPageDerivativeData = [];
  secondPageDerivativeRemberedData = [];

  vehicleId = "";
  thirdPageTitle = "";
  thirdVehicleId = "";
  secPageSelectedDuration = "";
  status = "ss";
  secondPageData = [];
  instrumentDetails = {};
  instrumentWholeData = { details: null, transaction: null };
  derivativeProfile = {};
  derivativeDetails = [];
  derivativeInstrumentDetails = [];
  secPageDerivateId = "";
  thirdInstruId = "";
  secPageReturnData = {};
  famOrClient = { name: "fam", id: "0" };
  futureOrOptions = "";
  tabClicked = false;
  showHoldingState = false;
  showHoldingDerivatives = "1";
  vehicleStatus = "default";
  monthDataStatus = "default";
  benchmarkStatus = "default";
  assteClassStaus = "default";
  investmentStatus = "default";
  loaderClosingCheck = {};
  loaderClosingCheckForImage = {};
  beforeFilterStatus = "";
  dateObj = { from: "", to: "" };
  loginLoader = false;
  mainTabLoader = false;
  inTableLoader = false;
  portfolioAssetPageLoader = false;
  infinityMainLoader = false;
  currentLoader = "";
  isFirstPageDataFetched = null;
  isDerivativeDataFetched = null;
  isSecPageDataFetched = null;
  isSecPageDerivativeFetched = null;
  selectedTransactionsInstrument = {};
  isDataSorted = null;
  nonDerivativeCheckedStatus = true;
  transacSelection = {
    selectedType: "Both",
    id: 0,
    isSelected: true,
  };
  optionSelection = {
    selectedType: "Both",
    id: "B",
    isSelected: true,
  };

  rememberedTransactionSelection = {
    selectedType: "Both",
    id: 0,
    isSelected: true,
  };
  rememberedOptionSelection = {
    selectedType: "Both",
    id: "B",
    isSelected: true,
  };

  isClassIdChecked = false;
  PerformanceApiCalled = null;

  lastTabName = "CUSTOM";

  fromDatePerf = null;
  toDatePerf = null;
  performanceData = [];
  persistedSecPageDuration = "";

  filterData = {
    timePeriod: {
      value: "notSelected",
      isSelected: false,
    },
  };

  performanceFilter = {
    timePeriod: {
      value: "notSelected",
      title: "",
      isSelected: false,
    },
    transactionType: {
      value: "Both",
      id: 0,
    },
    optionType: {
      value: "Both",
      id: "B",
    },
  };

  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "performance",
      properties: [
        "filterData",
        "persistedSecPageDuration",
        "fromDateStore",
        "transacSelection",
        "optionSelection",
        "toDateStore",
        "timePeriod",
        "isFilterApplied",
        "isSecondPagePresent",
        "isDateFilterApplied",
        "currentAppliedFilter",
        "selectedRefs",
        "selectedFirstRef",
        "mainRef",
        "selectedAssetClass",
        // "selectedDuration",//
        "selectedIndex",
        "selectedIndexForApi",
        "indexes",
        "assetClasses",
        "monthwiseData",
        "selectedTransactionsInstrument",
        "subTabs",
        // "firstPageTable",
        "dropdownData",
        "secondPageTitle",
        "vehicleId",
        "thirdPageTitle",
        "thirdVehicleId",
        // "secPageSelectedDuration",
        "status",
        "secondPageData",
        "rememberedTransactionSelection",
        "rememberedOptionSelection",
        //  "secondPageNormalData",
        "secondPageRememberedNormalData",
        "secondPageDerivativeData",
        "secondPageDerivativeRemberedData",
        // "instrumentDetails",
        // "instrumentWholeData",
        "derivativeProfile",
        "derivativeDetails",
        "derivativeInstrumentDetails",
        "secPageDerivateId",
        "thirdInstruId",
        "secPageReturnData",
        "famOrClient",
        "futureOrOptions",
        "showHoldingDerivatives",
        "vehicleStatus",
        "monthDataStatus",
        "benchmarkStatus",
        "assteClassStaus",
        "investmentStatus",
        "beforeFilterStatus",
        "dateObj",
        "isFirstPageDataFetched",
        "isDerivativeDataFetched",
        "isSecPageDataFetched",
        "isSecPageDerivativeFetched",
      ],
      storage: customStorage,
      expireIn: 86400000, // One day in milliseconds
      removeOnExpiration: true,
      stringify: false,
    });
  }

  setRef(refId, check) {
    this.selectedRefs = refId;
  }

  setDerivativeRef(data) {
    this.derivativeRef = data;
  }

  setFirstPageRef(refId) {
    this.selectedFirstRef = refId;
  }

  setMainRef(ref) {
    this.mainRef = ref;
  }

  setFutreOrOptios(data) {
    this.futureOrOptions = data;
  }
  setSecPageDerivateId(id) {
    this.secPageDerivateId = id;
  }

  setIsClassIdChecked(data, data1) {
    this.isClassIdChecked = data;
  }
  setPerformanceApiCalled(data) {
    this.PerformanceApiCalled = data;
  }

  setNonDerivativeCheckedStatus(data) {
    this.nonDerivativeCheckedStatus = data;
  }

  setIsDataSorted(data) {
    this.isDataSorted = data;
  }

  setInstrumentDetails(data) {
    this.instrumentDetails = data;
  }

  setSelectedTransactionInstrument(data) {
    this.selectedTransactionsInstrument = data;
  }

  setCurrentLoader(data) {
    this.currentLoader = data;
  }

  setFirstPageTableEmpty() {
    this.firstPageTable = [];
  }

  setDuration(data) {
    this.selectedDuration = data;
  }

  setSecPageDuration(data) {
    this.secPageSelectedDuration = data;
  }

  setAssetClassOnLinkClick(data) {
    this.selectedAssetClass = data;
  }

  setData(type, data, cc) {
    this[type] = data;
  }

  setIsFirstPageFetched(data) {
    this[data] = false;
  }

  setLoaderStatus(key, data) {
    this.loaderClosingCheck[key] = data;
  }
  setLoaderStatusForImage(key, data) {
    this.loaderClosingCheckForImage[key] = data;
  }

  setPerformanceLoader(type, data) {
    this[type] = data;
  }

  updateSecondPageData(data) {
    this.secondPageNormalData = data;
  }
  updateRememberedSecondPageData(data) {
    this.secondPageRememberedNormalData = data;
  }
  updateSecPageDerivativeData(data, fromsecond) {
    this.secondPageDerivativeData = data;
  }
  updateSecPageRememberedDerivativeData(data) {
    this.secondPageDerivativeRemberedData = data;
  }

  setIsSecPageDataFetched(data) {
    this.isSecPageDataFetched = data;
  }

  setIsSecpage(data) {
    this.isSecondPagePresent = data;
  }

  setFiltersSelection(type, data) {
    this[type] = data;
  }

  setIsDateFilterApplied(data) {
    this.isDateFilterApplied = data;
  }
  setCurrentAppliedFilter(data) {
    this.currentAppliedFilter = data;
  }

  setApiXirr(data) {
    this.dropdownData = data;
  }

  setIsSelectedIdPresent(value) {
    this.isSelectedPresent = value;
  }

  setDateInStore(fromDate, toDate) {
    this.fromDateStore = fromDate;
    this.toDateStore = toDate;
  }

  setFilterSelection(type, data) {
    if (type !== "initialState") this[type] = data;
    else {
      this.transacSelection = this.rememberedTransactionSelection;
      this.optionSelection = this.rememberedOptionSelection;
    }
  }

  setTimePeriod(data, condition) {
    const localdata = data;

    if (condition === "toggle") {
      this.timePeriod = {
        value: this.timePeriod.value,
        isSelected: !this.timePeriod.isSelected,
      };
    } else if (condition === "changeDuration") {
      this.timePeriod = {
        isSelected: true,
        value: data,
      };
    } else if (condition === "changeWholeValue") {
      this.timePeriod = localdata;
    }
  }

  setLoaderClosingCheck(data) {
    const newObj = data;
    this.loaderClosingCheck = newObj;
  }

  loaderCloseOnFail() {
    this.loaderClosingCheck = {};
    if (this.currentLoader === "fullScreen") {
      AuthStore.updateLoadingFullScreen(false);
    } else if (this.currentLoader === "mainTabLoader") {
      this.setPerformanceLoader("mainTabLoader", false);
    } else if (this.currentLoader === "inTableLoader") {
      this.setPerformanceLoader("inTableLoader", false);
    } else if (this.currentLoader === "modalLoader") {
      this.setPerformanceLoader("modalLoader", false);
    } else {
      this.setPerformanceLoader(this.currentLoader, false);
      AuthStore.updateLoadingFullScreen(false);
    }
    AuthStore.updateLoadingFullScreen(false);
    this.setPerformanceLoader("mainTabLoader", false);
    this.setPerformanceLoader("inTableLoader", false);
  }

  loaderCloseFunction() {
    let i = null;
    const objKeysArr = Object.keys(this.loaderClosingCheck);
    for (i = 0; i < objKeysArr.length; i++) {
      if (this.loaderClosingCheck[objKeysArr[i]] === "pending") {
        break;
      }
    }
    if (i === objKeysArr.length) {
      if (this.currentLoader === "fullScreen") {
        AuthStore.updateLoadingFullScreen(false, "perf");
      } else if (this.currentLoader === "mainTabLoader") {
        this.setPerformanceLoader("mainTabLoader", false);
      } else if (this.currentLoader === "inTableLoader") {
        this.setPerformanceLoader("inTableLoader", false);
      } else if (this.currentLoader === "modalLoader") {
        this.setPerformanceLoader("modalLoader", false);
      } else if (this.currentLoader === "loginLoader") {
        this.setPerformanceLoader("loginLoader", false);
      } else if (this.currentLoader === "infinityMainLoader") {
        this.setPerformanceLoader("infinityMainLoader", false);
      } else if (this.currentLoader === "portfolioAssetPageLoader") {
        this.setPerformanceLoader("portfolioAssetPageLoader", false);
      }

      this.loaderCloseOnFail();
      this.setLoaderClosingCheck({});
    }
  }

  setShowHolding(data) {
    this.showHoldingDerivatives = data;
    this.showHoldingState = !data;
  }

  setSecPageData(data) {}

  setAssetClassOnly() {
    this.selectedAssetClass = { id: "all", name: "Overall" };
  }
  setFamOrClient(data) {
    const data1 = data;
    this.famOrClient = data1;
  }

  setSecPageTitle(data) {
    this.secondPageTitle = data?.name + " Performance";
    this.vehicleId = data?.id;
  }
  setThirdPageTitle(data) {
    this.thirdPageTitle = data?.name;
    this.thirdVehicleId = data?.measureinstrumentid;
    this.thirdInstruId = data?.id;
  }

  setTableData(dropDownData) {
    const newArr = this.firstPageTable.map((data) => {
      return { ...data, benchmark: this.dropDownData.xirr };
    });
    this.firstPageTable = newArr;
    this.isFirstPageDataFetched = true;
  }

  setIndex(data) {
    this.selectedIndex = data?.name;
    this.selectedIndexForApi = data?.id;
  }
  setAssetClass(data, duration) {
    const newData = data;
    this.tabClicked = true;
    this.selectedAssetClass = newData;
    this.setDuration(duration ? duration : this.subTabs[0]);
  }

  *getInstrumentDetails(assetClassId, subAssetClassId, folioId) {
    const familyId = UserStore.userData?.family_id || getCookie("famid");

    const clientId = UserStore.userData.user_id || getCookie("userid");
    if (this.famOrClient.name === "fam") {
      try {
        this.setLoaderStatus("instDetStatus", "pending");
        const response = yield getTransactionDetails({
          isFamily: "families",
          id: familyId,
          assetClassId,
          subAssetClassId,
          folioId,
          advisor: UserStore.getDataWithNuvamaOrOther,
        });
        this.instrumentDetails = response.data;
        if (response.status === 200) {
          this.setLoaderStatus("instDetStatus", "success");
        }
        this.loaderCloseFunction();
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
      }
    } else {
      try {
        this.setLoaderStatus("instDetStatus", "pending");
        const response = yield getTransactionDetails({
          isFamily: "clients",
          id: clientId,
          assetClassId,
          subAssetClassId,
          folioId,
          advisor: UserStore.getDataWithNuvamaOrOther,
        });
        this.instrumentDetails = response.data;
        if (response.status === 200) {
          this.setLoaderStatus("instDetStatus", "success");
        }
        this.loaderCloseFunction();
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
      }
    }
  }

  *getTransaction(measureId, folioId) {
    const familyId = UserStore.userData?.family_id || getCookie("famid");
    const clientId = UserStore.userData.user_id || getCookie("userid");

    if (this.famOrClient.name === "fam") {
      try {
        this.setLoaderStatus("trascStatus", "pending");
        const response = yield getTransaction({
          isFamily: "families",
          id: familyId,
          measureId,
          folioId,
        });
        this.instrumentWholeData = {
          details: this.instrumentDetails,
          transaction: response.data,
        };
        if (response.status === 200) {
          this.setLoaderStatus("trascStatus", "success");
        }
        this.loaderCloseFunction();
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
      }
    } else {
      try {
        this.setLoaderStatus("trascStatus", "pending");
        const response = yield getTransaction({
          isFamily: "clients",
          id: clientId,
          measureId,
          folioId,
        });
        this.instrumentWholeData = {
          details: this.instrumentDetails,
          transaction: response.data,
        };
        if (response.status === 200) {
          this.setLoaderStatus("trascStatus", "success");
        }
        this.loaderCloseFunction();
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
      }
    }
  }

  *getDataPerAssetClass(classId, duration, advisor) {
    const familyId = UserStore.userData?.family_id || getCookie("famid");
    const clientId = UserStore.userData.user_id || getCookie("userid");

    if (this.famOrClient.name === "fam") {
      try {
        this.setLoaderStatus("monthDataStatus", "pending");
        const response = yield getDataPerAsset({
          familyId,
          classId,
          duration,
          advisor,
        });

        this.monthwiseData = response.data;
        if (response.status === 200) {
          this.setLoaderStatus("monthDataStatus", "success");
        }

        this.loaderCloseFunction();
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
      }
    } else {
      try {
        this.setLoaderStatus("monthDataStatus", "pending");
        const response = yield getDataPerAssetClient({
          clientId,
          classId,
          duration,
          advisor,
        });

        this.monthwiseData = response.data;
        if (response.status === 200) {
          this.setLoaderStatus("monthDataStatus", "success");
        }
        this.loaderCloseFunction();
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
      }
    }
  }

  *getVehicles(sentClass, duration) {
    const familyId = UserStore.userData?.family_id || getCookie("famid");
    const clientId = UserStore.userData.user_id || getCookie("userid");
    this.setIsFirstPageFetched("isFirstPageDataFetched");

    if (this.famOrClient.name === "fam") {
      try {
        this.setLoaderStatus("vehicleStatus", "pending");
        const response = yield perVehicle({
          duration: this.selectedDuration,
          advisor: UserStore.getDataWithNuvamaOrOther,
          sentClass,
          assetClass: this.selectedAssetClass,
          familyId,
        });
        const newArr = response.data.map((data) => {
          return { ...data, benchmark: this.dropdownData.xirr };
        });

        const filteredArray = newArr.filter((data) => {
          return (
            Number(Number(data.absoluteReturn.return.actual_value).toFixed()) +
              Number(Number(data.absoluteReturn.xirr).toFixed()) !==
            0
          );
        });
        this.firstPageTable = filteredArray;
        this.isFirstPageDataFetched = true;
        if (response.status === 200) {
          this.setLoaderStatus("vehicleStatus", "success");
        }

        this.loaderCloseFunction();
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
      }
    } else {
      try {
        this.setLoaderStatus("vehicleStatus", "pending");
        const response = yield perVehicleClient({
          duration: this.selectedDuration,
          advisor: UserStore.getDataWithNuvamaOrOther,
          sentClass,
          assetClass: this.selectedAssetClass,
          clientId,
        });
        const newArr = response.data.map((data) => {
          return { ...data, benchmark: this.dropdownData.xirr };
        });

        this.firstPageTable = newArr;

        const filteredArray = newArr.filter((data) => {
          return (
            Number(Number(data.absoluteReturn.return.actual_value).toFixed()) +
              Number(Number(data.absoluteReturn.xirr).toFixed()) !==
            0
          );
        });
        this.firstPageTable = filteredArray;
        this.isFirstPageDataFetched = true;
        if (response.status === 200) {
          this.setLoaderStatus("vehicleStatus", "success");
        }

        this.loaderCloseFunction();
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
      }
    }
  }

  *getSecondPageData(assetClassId, subAssetClassId, onSuccess, onFail) {
    const familyId = UserStore.userData?.family_id || getCookie("famid");
    const clientId = UserStore.userData.user_id || getCookie("userid");
    if (this.famOrClient.name === "fam") {
      try {
        this.setLoaderStatus("secPageStatus", "pending");
        const response = yield secondPageData({
          id: familyId,
          isFamily: "families",
          Duration: this.secPageSelectedDuration,
          advisor: UserStore.getDataWithNuvamaOrOther,
          assetClassId,
          subAssetClassId,
        });
        this.secondPageData = response.data;
        this.updateRememberedSecondPageData(response.data);
        this.isSecPageDataFetched = true;
        if (response.status === 200) {
          this.setLoaderStatus("secPageStatus", "success");
        }
        this.loaderCloseFunction();
        onSuccess && onSuccess({ data: response.data, type: "data" });
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
        onFail && onFail(error, "data");
      }
    } else {
      try {
        this.setLoaderStatus("secPageStatus", "pending");
        const response = yield secondPageData({
          id: clientId,
          isFamily: "clients",
          Duration: this.secPageSelectedDuration,
          advisor: UserStore.getDataWithNuvamaOrOther,
          assetClassId,
          subAssetClassId,
        });
        this.secondPageData = response.data;
        this.updateRememberedSecondPageData(response.data);
        this.isSecPageDataFetched = true;
        if (response.status === 200) {
          this.setLoaderStatus("secPageStatus", "success");
        }
        this.loaderCloseFunction();
        onSuccess && onSuccess({ data: response.data, type: "data" });
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
        onFail && onFail(error, "data");
      }
    }
  }
  *getSecPageReturns(assetClassId, subAssetClassId, onSuccess, onFail) {
    const familyId = UserStore.userData?.family_id || getCookie("famid");
    const clientId = UserStore.userData.user_id || getCookie("userid");
    if (this.famOrClient.name === "fam") {
      try {
        this.setLoaderStatus("secPerturnStatus", "pending");
        const response = yield secPageReturns({
          isFamily: "families",
          id: familyId,
          assetClassId,
          subAssetClassId,
          duration: this.secPageSelectedDuration,
          advisor: UserStore.getDataWithNuvamaOrOther,
        });
        this.secPageReturnData = response.data;
        if (response.status === 200) {
          this.setLoaderStatus("secPerturnStatus", "success");
        }
        this.loaderCloseFunction();
        onSuccess && onSuccess({ data: response.data, type: "returns" });
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
        onFail && onFail(error, "returns");
      }
    } else {
      try {
        this.setLoaderStatus("secPerturnStatus", "pending");
        const response = yield secPageReturns({
          isFamily: "clients",
          id: clientId,
          assetClassId,
          subAssetClassId,
          duration: this.secPageSelectedDuration,
          advisor: UserStore.getDataWithNuvamaOrOther,
        });
        this.secPageReturnData = response.data;
        if (response.status === 200) {
          this.setLoaderStatus("secPerturnStatus", "success");
        }
        this.loaderCloseFunction();
        onSuccess && onSuccess({ data: response.data, type: "returns" });
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
        onFail && onFail(error, "returns");
      }
    }
  }

  getSubAssetDataOnSnippetNavigation({
    location,
    assetClassId,
    subAssetClassId,
  }) {
    const { parentSection, assetClassId: id, duration } = location.state;

    this.setData("selectedAssetClass", {
      id,
      name: parentSection,
    });
    this.setData("secPageSelectedDuration", duration);
    this.setData("selectedDuration", duration);

    const onSuccess = (data) => {
      this.setData("subTabs", getAssetInternalTabs(data, "name"));
    };
    const onFail = (error) => {};

    this.getDuraion({ onSuccess, onFail });

    this.onInternalTabChangesecondPageOrRedirect({
      assetClassId,
      subAssetClassId,
      onSuccess: ({ data, type }) => {},
      onFail: (error, type) => {},
    });
  }

  // Apis For Derivatives
  *getDerivativeProfile(duration) {
    const family_id = UserStore.userData?.family_id || getCookie("famid");
    const clientId = UserStore.userData.user_id || getCookie("userid");

    const isCustom = !derivativeTabs.includes(duration);
    const famData =
      this.famOrClient.name === "fam"
        ? {
            family_id,
            user_id: UserStore.currentFamilyMembers[0].user_id,
            duration,
            isfamilyhead: "1",
          }
        : {
            family_id: "0",
            user_id: clientId,
            duration,
            isfamilyhead: UserStore.selectedMemberIsPrimary ? "1" : "0",
          };
    const payload = !isCustom
      ? {
          ...famData,
        }
      : {
          fromdate: getDateStrPerformance(this.fromDatePerf),
          todate: getDateStrPerformance(this.toDatePerf),
          ...famData,
          duration: "ITD",
          isCustomise: "C",
        };

    try {
      this.setLoaderStatus("derProStatus", "pending");
      const response = yield derivativeProfile({ ...payload });
      this.derivativeProfile = response.data[0];
      if (response.status === 200) {
        this.setLoaderStatus("derProStatus", "success");
      }
      this.loaderCloseFunction();
    } catch (error) {
      this.status = error;
      this.loaderCloseOnFail();
    }
  }
  *getDerivativeProfileDetails(duration) {
    const family_id = UserStore.userData?.family_id || getCookie("famid");
    const clientId = UserStore.userData.user_id || getCookie("userid");
    this.setIsFirstPageFetched("isDerivativeDataFetched");

    const isCustom = !derivativeTabs.includes(duration);
    const famData =
      this.famOrClient.name === "fam"
        ? {
            family_id,
            user_id: UserStore.currentFamilyMembers[0].user_id,
            isfamilyhead: "1",
            duration,
          }
        : {
            family_id: "0",
            user_id: clientId,
            isfamilyhead: UserStore.selectedMemberIsPrimary ? "1" : "0",
            duration,
          };
    const payload = !isCustom
      ? {
          ...famData,
        }
      : {
          fromdate: getDateStrPerformance(this.fromDatePerf),
          todate: getDateStrPerformance(this.toDatePerf),
          ...famData,
          duration: "ITD",
          isCustomise: "C",
        };

    try {
      this.setLoaderStatus("derProDetStatus", "pending");
      const response = yield derivativeProfileDetails({
        ...payload,
      });

      let tempData = response.data;
      let arr2 = tempData[0].derivativeSubAssetClass_Details?.map(
        (data, index) =>
          data.derivativetypeid === "1"
            ? { ...data, derivativeName: "Futures" }
            : { ...data, derivativeName: "Options" }
      );
      this.derivativeDetails = arr2;
      this.isDerivativeDataFetched = true;

      if (response.status === 200) {
        this.setLoaderStatus("derProDetStatus", "success");
      }
      this.loaderCloseFunction();
    } catch (error) {
      this.status = error;
      this.loaderCloseOnFail();
    }
  }
  *getDerivativeInstrumentDetails() {
    const familyId = UserStore.userData?.family_id || getCookie("famid");

    const clientId = UserStore.userData.user_id || getCookie("userid");
    if (this.famOrClient.name === "fam") {
      try {
        this.setLoaderStatus("derInsDetStatus", "pending");
        const response = yield apiClient.get(
          `GetDerivativeInstrumentDetails?family_id=${familyId}&user_id=${UserStore.currentFamilyMembers[0].user_id}&showmestockflag=${this.showHoldingDerivatives}&assetclassid=6&vehicleid=16&duration=${this.secPageSelectedDuration}&advisor=${UserStore.getDataWithNuvamaOrOther}&returntype=${this.secPageDerivateId}&fromdate&todate&transactiontype&byoptiontype&familymemberlist`
        );
        this.derivativeInstrumentDetails = response.data;
        this.updateSecPageDerivativeData(
          response.data?.[0]?.performanceDerivativeInstrumentDetails
        );
        this.updateSecPageRememberedDerivativeData(
          response.data?.[0]?.performanceDerivativeInstrumentDetails
        );
        this.isSecPageDerivativeFetched = true;
        if (response.status === 200) {
          this.setLoaderStatus("derInsDetStatus", "success");
        }
        this.loaderCloseFunction();
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
      }
    } else {
      try {
        this.setLoaderStatus("derInsDetStatus", "pending");
        const response = yield apiClient.get(
          `GetDerivativeInstrumentDetails?family_id=0&user_id=${clientId}&showmestockflag=${this.showHoldingDerivatives}&assetclassid=6&vehicleid=16&duration=${this.secPageSelectedDuration}&advisor=${UserStore.getDataWithNuvamaOrOther}&returntype=${this.secPageDerivateId}&fromdate&todate&transactiontype&byoptiontype&familymemberlist`
        );
        this.derivativeInstrumentDetails = response.data;
        this.updateSecPageDerivativeData(
          response.data?.[0]?.performanceDerivativeInstrumentDetails
        );
        this.updateSecPageRememberedDerivativeData(
          response.data?.[0]?.performanceDerivativeInstrumentDetails
        );
        this.isSecPageDerivativeFetched = true;
        if (response.status === 200) {
          this.setLoaderStatus("derInsDetStatus", "success");
        }
        this.loaderCloseFunction();
      } catch (error) {
        this.status = error;
        this.loaderCloseOnFail();
      }
    }
  }

  setPerformanceDate(dateObj) {
    this.dateObj = {
      from: dateObj.from,
      to: dateObj.to,
    };
  }

  setFilterApplied(closeState) {
    if (!closeState) {
      this.isFilterApplied = true;
    } else {
      this.isFilterApplied = false;
    }
  }

  setFiltersToInitialState() {
    this.setFilterApplied("closeState");
    this.setIsDateFilterApplied(false);
    const transaction = {
      selectedType: "Both",
      id: 0,
      isSelected: true,
    };
    const option = {
      selectedType: "Both",
      id: "B",
      isSelected: true,
    };
    const defaultValue = {
      date: "",
      month: "",
      year: "",
    };

    this.setFiltersSelection("transacSelection", transaction);
    this.setFiltersSelection("optionSelection", option);
    this.setTimePeriod(
      { value: "notSelected", isSelected: false },
      "changeWholeValue"
    );
    this.setFiltersSelection("rememberedTransactionSelection", transaction);
    this.setFiltersSelection("rememberedOptionSelection", option);
    this.setDateInStore(defaultValue, defaultValue);
    this.setPerformanceDate({ from: "", to: "" });
  }

  // setFiltersToInitialState() {
  //   this.setFilterApplied("closeState");
  //   this.setIsDateFilterApplied(false);

  //   const transaction = {
  //     selectedType: "Both",
  //     id: 0,
  //     isSelected: true,
  //   };
  //   const option = {
  //     selectedType: "Both",
  //     id: "B",
  //     isSelected: true,
  //   };
  //   const defaultValue = {
  //     date: "",
  //     month: "",
  //     year: "",
  //   };

  //   this.setFiltersSelection("transacSelection", transaction);
  //   this.setFiltersSelection("optionSelection", option);
  //   this.setTimePeriod(
  //     { value: "notSelected", isSelected: false },
  //     "changeWholeValue"
  //   );
  //   this.setFiltersSelection("rememberedTransactionSelection", transaction);
  //   this.setFiltersSelection("rememberedOptionSelection", option);
  //   this.setDateInStore(defaultValue, defaultValue);
  //   this.setPerformanceDate({ from: "", to: "" });
  // }

  // *getFilterData(transactionType, optionType, isClosed, performanceRoute2) {
  //   const family_id = UserStore.userData?.family_id || getCookie("famid");
  //   const clientId = UserStore.userData.user_id || getCookie("userid");
  //   const famData =
  //     this.famOrClient.name === "fam"
  //       ? {
  //           family_id,
  //           user_id: UserStore.currentFamilyMembers[0].user_id,
  //           showmestockflag: this.showHoldingDerivatives,
  //           duration: this.secPageSelectedDuration,
  //           advisor: UserStore.getDataWithNuvamaOrOther,
  //           returntype: performanceRoute2,
  //           transactiontype: transactionType,
  //           byoptiontype: optionType,
  //           familymemberlist: "",
  //         }
  //       : {
  //           familyId: "0",
  //           user_id: clientId,
  //           showmestockflag: this.showHoldingDerivatives,
  //           duration: this.secPageSelectedDuration,
  //           advisor: UserStore.getDataWithNuvamaOrOther,
  //           returntype: performanceRoute2,
  //           transactiontype: transactionType,
  //           byoptiontype: optionType,
  //           familymemberlist: "",
  //         };
  //   const payload = this.filterData.timePeriod.isSelected
  //     ? {
  //         fromdate: this.dateObj.from,
  //         todate: this.dateObj.to,
  //         ...famData,
  //       }
  //     : {
  //         ...famData,
  //         fromDate: "",
  //         todate: "",
  //       };
  //   try {
  //     this.setLoaderStatus("filterFirstStatus", "pending");

  //     const response = yield derivativeFilter({ ...payload });

  //     this.derivativeInstrumentDetails = response.data;
  //     this.updateSecPageDerivativeData(
  //       response.data?.[0]?.performanceDerivativeInstrumentDetails
  //     );
  //     this.updateSecPageRememberedDerivativeData(
  //       response.data?.[0]?.performanceDerivativeInstrumentDetails
  //     );
  //     this.isSecPageDerivativeFetched = true;
  //     //  this.setIsDateFilterApplied(true);
  //     this.setCurrentAppliedFilter(this.timePeriod.value);
  //     this.setFilterApplied(isClosed);

  //     if (response.status === 200) {
  //       this.setLoaderStatus("filterFirstStatus", "success");
  //     }
  //     this.loaderCloseFunction();
  //   } catch (error) {
  //     this.setFilterApplied();
  //     this.status = error;
  //     this.loaderCloseOnFail();
  //   }
  // }

  *getFilterData(transactionType, optionType, isClosed, performanceRoute2) {
    const family_id = UserStore.userData?.family_id || getCookie("famid");
    const clientId = UserStore.userData.user_id || getCookie("userid");
    const isCustom = !derivativeTabs.includes(this.secPageSelectedDuration);
    const dataObj = {
      showmestockflag: this.showHoldingDerivatives,
      duration: this.secPageSelectedDuration,
      advisor: UserStore.getDataWithNuvamaOrOther,
      returntype: performanceRoute2,
      transactiontype: transactionType,
      byoptiontype: optionType,
      familymemberlist: "",
    };
    const famData =
      this.famOrClient.name === "fam"
        ? {
            family_id,
            user_id: UserStore.currentFamilyMembers[0].user_id,
            ...dataObj,
          }
        : {
            familyId: "0",
            user_id: clientId,
            ...dataObj,
          };

    // const payload = this.filterData.timePeriod.isSelected
    //   ? {
    //       fromdate: this.dateObj.from,
    //       todate: this.dateObj.to,
    //       ...famData,
    //     }
    //   : {
    //       ...famData,
    //       fromDate: "",
    //       todate: "",
    //     };

    const payload = !isCustom
      ? this.filterData.timePeriod.isSelected
        ? {
            fromdate: this.dateObj.from,
            todate: this.dateObj.to,
            ...famData,
          }
        : {
            ...famData,
            fromDate: "",
            todate: "",
          }
      : {
          ...famData,
          fromdate: getDateStrPerformance(this.fromDatePerf),
          todate: getDateStrPerformance(this.toDatePerf),
          duration: "ITD",
          isCustomise: "C",
        };

    try {
      this.setLoaderStatus("filterFirstStatus", "pending");

      const response = yield derivativeFilter({ ...payload });

      this.derivativeInstrumentDetails = response.data;
      this.updateSecPageDerivativeData(
        response.data?.[0]?.performanceDerivativeInstrumentDetails
      );
      this.updateSecPageRememberedDerivativeData(
        response.data?.[0]?.performanceDerivativeInstrumentDetails
      );
      this.isSecPageDerivativeFetched = true;
      //this.setIsDateFilterApplied(true);
      //  this.setIsDateFilterApplied(true);
      this.setCurrentAppliedFilter(this.timePeriod.value);
      this.setFilterApplied(isClosed);
      // this.setFilterApplied(isClosed);

      if (response.status === 200) {
        this.setLoaderStatus("filterFirstStatus", "success");
      }
      this.loaderCloseFunction();
    } catch (error) {
      this.setFilterApplied();
      // this.setFilterApplied();
      this.status = error;
      this.loaderCloseOnFail();
    }
  }

  getPortAssetClasses(data) {
    const familyId = UserStore.userData?.family_id || getCookie("famid");
    const clientId = UserStore.userData.user_id || getCookie("userid");
    if (this.famOrClient.name === "fam") {
      this.setLoaderStatus("assteClassStaus", "pending");
      getAssetClasses({ familyId, advisor: UserStore.getDataWithNuvamaOrOther })
        .then((data) => {
          this.assetClasses = [{ id: "all", name: "Overall" }, ...data?.data];
          this.setLoaderStatus("assteClassStaus", "success");
          this.loaderCloseFunction();
        })
        .catch((error) => {
          this.status = error;
          this.loaderCloseOnFail();
        });
    } else {
      this.setLoaderStatus("assteClassStaus", "pending");
      getAssetClassesClient({
        clientId,
        advisor: UserStore.getDataWithNuvamaOrOther,
      })
        .then((data) => {
          this.assetClasses = [{ id: "all", name: "Overall" }, ...data?.data];
          this.setLoaderStatus("assteClassStaus", "success");
          this.loaderCloseFunction();
        })
        .catch((error) => {
          this.status = error;
          this.loaderCloseOnFail();
        });
    }
  }

  getInvestmentHeldWith(user_id) {
    this.setLoaderStatus("investmentStatus", "pending");

    apiClient
      .get(`clients/${user_id}`)
      .then(({ data }) => {
        UserStore.setUserData(data);
      })
      .then(() => {
        this.setLoaderStatus("investmentStatus", "success");
        this.getPortAssetClasses();
        this.getFirstPageData();
        this.loaderCloseFunction();
      })
      .catch((error) => {
        this.status = error;
        this.loaderCloseOnFail();
      });
  }

  callBenchMarkApi({ duration, onSuccess, onFail }) {
    benchMarkData({
      index: this.selectedIndexForApi,
      duration: duration,
      selectedDuration: this.selectedDuration,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        this.loaderCloseOnFail();
        onFail(error);
      });
  }

  setFirstTable(duration) {
    const tempArr = this.firstPageTable;
    const mappedArray = tempArr.map((data) => {
      return { ...data, benchmark: this.dropdownData.xirr };
    });
    this.firstPageTable = mappedArray;
    this.isFirstPageDataFetched = true;
  }

  getBenchMarkData(condition, duration) {
    this.setLoaderStatus("benchmarkStatus", "pending");
    this.callBenchMarkApi({
      duration,
      onSuccess: (data) => {
        this.setApiXirr(data);
        if (condition) {
          this.setFirstTable(duration);
        }
        this.setLoaderStatus("benchmarkStatus", "success");
        this.loaderCloseFunction();
      },
      onFail: (error) => {
        this.loaderCloseOnFail();
      },
    });
  }

  getDuraion({ onSuccess, onFail }) {
    performanceDuration()
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        this.loaderCloseOnFail();
        onFail(error);
      });
  }

  getThenDuration(dataCondition) {
    this.getDuraion({
      onSuccess: (data) => {
        this.selectedDuration = this.isAssetClassClicked
          ? this.selectedDuration
          : data[0].name;
        this.secPageSelectedDuration = data[0].name;
        this.subTabs = getAssetInternalTabs(data, "name");
        this.getBenchMarkData();
        if (dataCondition) {
          this.getPortAssetClasses();
          this.getFirstPageData();
        }
      },
    });
  }

  getIndexFirst({ onSuccess, onFail }) {
    getIndex()
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        this.loaderCloseOnFail();
        onFail(error);
      });
  }

  getFirstPageData() {
    if (this.selectedAssetClass.id !== 6) {
      this.getDataPerAssetClass(
        this.selectedAssetClass,
        this.selectedDuration,
        UserStore.getDataWithNuvamaOrOther
      );
      if (this.selectedAssetClass.id !== "all") {
        this.getVehicles(this.selectedAssetClass);
      }
    } else {
      this.getDerivativeProfile(this.selectedDuration);
      this.getDerivativeProfileDetails(this.selectedDuration);
    }
  }

  getDerivatesData() {
    this.getDerivativeProfile(this.selectedDuration);
    this.getDerivativeProfileDetails(this.selectedDuration);
  }

  getIndexAndDuration(dataCondition) {
    this.getIndexFirst({
      onSuccess: (data) => {
        this.selectedIndex = data?.[2]?.name;
        this.selectedIndexForApi = data?.[2]?.id;
        this.indexes = data;
        this.getThenDuration(dataCondition);
      },
      onFail: (error) => {},
    });
  }

  handle(dataCondition) {
    if (
      (this.famOrClient.name === "fam" &&
        UserStore.currentFamilyMembers === undefined) ||
      (this.famOrClient.name === "fam" &&
        UserStore.getDataWithNuvamaOrOther === "")
    ) {
      UserStore.getFamilyClients("performance");
    } else if (
      this.famOrClient.name !== "fam" &&
      UserStore.getDataWithNuvamaOrOther === ""
    ) {
      this.getInvestmentHeldWith(
        UserStore.userData.user_id || getCookie("userid")
      );
    } else {
      this.getIndexAndDuration(dataCondition);
    }
  }

  onFamClientMainTab() {
    if (this.selectedAssetClass.id === 4) {
      this.setIndex({ name: "Crisil Bond", id: "5" });
      this.getBenchMarkData("setTable");
    } else if (this.selectedAssetClass.id !== 6) {
      this.setIndex({ name: "CNX 50 TRI", id: "3" });
      this.getBenchMarkData("setTable");
    }
  }

  getAbsoluteDataL2(data, subAssetClassId) {
    const subAssetData = data?.find(
      (data) => data.investmentVehicleId === subAssetClassId
    );
    this.secPageReturnData = {
      absoluteReturn: {
        as_of_date: getDateStrPerformance(this.toDatePerf),
        return: subAssetData?.amount,
        xirr: subAssetData?.xirr,
      },
    };
  }

  onMainTabChange() {
    if (this.selectedDuration.length < 6) {
      this.getFirstPageData();
      this.onFamClientMainTab();
    } else {
      if (this.selectedAssetClass.id === 4) {
        this.setIndex({ name: "Crisil Bond", id: "5" });
      } else if (this.selectedAssetClass.id !== 6) {
        this.setIndex({ name: "CNX 50 TRI", id: "3" });
      }
      if (this.selectedAssetClass.id === 6) {
        this.getDerivatesData();
      } else {
        this.getCustomDateData();
      }
    }
  }
  onInternalTabChangeFirstPage(tableCondition, duration) {
    this.getFirstPageData();
    this.getBenchMarkData("setTable", duration);
  }

  getInstruments(performanceData, subAssetClassId) {
    const data = toJS(performanceData?.performanceInstumentData)
      .filter((allData) => allData.investmentVehicleId === subAssetClassId)
      .map((instrument) => {
        return {
          current_value: instrument.curr_Amount,
          investmentPerformance: {
            return: instrument.abs_Amount,
            xirr: instrument.xirr,
            withholdings: instrument.withholdings,
          },
          instrument: {
            name: instrument.instrumentName,
            id: instrument.instrumentid,
            measureinstrumentid: instrument.measureInstrumentId,
          },
        };
      });
    return data;
  }

  onInternalTabChangesecondPageOrRedirect({
    assetClassId,
    subAssetClassId,
    onSuccess,
    onFail,
  }) {
    if (this.secPageSelectedDuration.length < 6) {
      this.getSecondPageData(assetClassId, subAssetClassId, onSuccess, onFail);
      this.getSecPageReturns(assetClassId, subAssetClassId, onSuccess, onFail);
    } else {
      this.setLoaderStatus("secPageStatus", "pending");
      if (this.performanceData?.performanceInstumentData?.length) {
        this.updateRememberedSecondPageData(
          this.getInstruments(this.performanceData, subAssetClassId)
        );
        this.getAbsoluteDataL2(
          this.performanceData?.performanceSubAssetData,
          subAssetClassId
        );
        this.isSecPageDataFetched = true;
        this.setLoaderStatus("secPageStatus", "success");
        this.loaderCloseFunction();
      } else {
        this.getCustomDataSubAssetClass(subAssetClassId);
      }
    }
  }
  onInternalTabChangeFirstPageDerivative() {
    this.getFirstPageData();
  }
  onInternalTabChangeSecPageDerivativeOrRedirect(
    transacSelection,
    optionSelection,
    performanceRoute2,
    from
  ) {
    this.getDerivativeProfile(this.secPageSelectedDuration);

    this.getFilterData(
      transacSelection.id,
      optionSelection.id,
      "closed",
      performanceRoute2
    );
  }

  setPerformanceLastTabToInitial() {
    this.setData("fromDatePerf", null);
    this.setData("toDatePerf", null);
    this.setData("lastTabName", "CUSTOM");
  }

  customExcel({ payload, excelMeta, onSuccess, onFail }) {
    getCustomExcel({ ...payload })
      .then((response) => {
        const excelData = performanceExcelData2({
          data: response.data,
          ...excelMeta,
        });

        onSuccess({ data: excelData });
      })
      .catch((error) => {
        onFail({ error });
      });
  }

  getOverallCustomExcelData({
    excelColumns,
    benchXirr,
    withHoldings,
    onSuccess,
    onFail,
  }) {
    const familyId = UserStore.userData?.family_id || getCookie("famid");
    const clientId = UserStore.userData?.user_id || getCookie("userid");

    const famData =
      this.famOrClient.name === "fam"
        ? {
            accounttype: "Family",
            isFam: true,
            subUrl: `families/${familyId}`,
          }
        : {
            accounttype: "Client",
            isFam: false,
            subUrl: `Clients/${clientId}`,
          };

    const dates = {
      fromdate: getDateStrPerformance(this.fromDatePerf),
      todate: getDateStrPerformance(this.toDatePerf),
    };

    const rtdetails = UserStore?.exportDetails;
    const { family_name, full_name } = UserStore.userData;

    const reportDetails = {
      relatioshipManager: rtdetails?.find((item) => item.role === "RM")?.name,
      serviceManager: rtdetails?.find((item) => item.role === "CXO")?.name,
      date: getPrintDate(UserStore.asOfDate),
      clientName: UserStore.getData === "fam" ? family_name : full_name,
    };
    const excelName = `${`Performance Report - ${
      this.famOrClient.name === "fam" ? family_name : full_name
    }`} - ${getCurrentDate()}`;

    const details = { reportDetails, excelName };

    let fixedIncomeBM = null;

    const exportExcelFile = ({ excelApiData }) => {
      exportExcel({
        dateRange: `${getDateString(this.fromDatePerf)} To ${getDateString(
          this.toDatePerf
        )}`,
        sheetname: `Performance Report`,
        columns: excelColumns,
        data: Object.values(excelApiData).flat(),
        ...details,
        customExcelTableStyle: ({ worksheet, data }) =>
          performanceOverallExcelStyle({ worksheet, data }),
      });
    };

    customBenchMark({
      ...dates,
      indextypeid: 5,
    })
      .then((response) => {
        fixedIncomeBM = response.data?.performanceBenchmark?.xirr;
        this.customExcel({
          payload: {
            ...dates,
            ...famData,
          },
          excelMeta: {
            benchXirr,
            withHoldings,
            fixedIncomeBM,
          },
          onSuccess: ({ data }) => {
            exportExcelFile({ excelApiData: data });
            onSuccess();
          },
          onFail: ({ error }) => {
            onFail({ error });
          },
        });
      })
      .catch((error) => {
        onFail({ error });
      });
  }

  *getCustomDataSubAssetClass(subAssetClassId) {
    const familyId = UserStore.userData?.family_id || getCookie("famid");
    const clientId = UserStore.userData.user_id || getCookie("userid");
    const assetId = this.selectedAssetClass.id;

    const famData =
      this.famOrClient.name === "fam"
        ? {
            accounttype: "Family",
            isFam: true,
            subUrl: `families/${familyId}`,
          }
        : {
            accounttype: "Client",
            isFam: false,
            subUrl: `Clients/${clientId}`,
          };

    const asset = {
      assetclassid: assetId !== "all" ? assetId : "",
      ...famData,
    };

    try {
      this.setLoaderStatus("secPageStatus", "pending");
      const response = yield customData({
        fromdate: getDateStrPerformance(this.fromDatePerf),
        todate: getDateStrPerformance(this.toDatePerf),
        ...asset,
      });
      let tableData = [];
      this.getAbsoluteDataL2(
        response.data?.performanceSubAssetData,
        subAssetClassId
      );
      if (response.data?.performanceInstumentData?.length) {
        tableData = this.getInstruments(response.data, subAssetClassId);
      }
      if (response.status === 200) {
        this.secondPageData = tableData;
        this.updateRememberedSecondPageData(tableData);
        this.isSecPageDataFetched = true;
        this.setLoaderStatus("secPageStatus", "success");
      }
      this.loaderCloseFunction();
    } catch (error) {
      this.secondPageData = [];
      this.getAbsoluteDataL2(
        [
          {
            id: 0,
            amount: 0,
            xirr: null,
          },
        ],
        0
      );
      this.updateRememberedSecondPageData([]);
      this.setLoaderStatus("secPageStatus", "success");
      this.loaderCloseFunction();
    }
  }

  *getCustomData() {
    const familyId = UserStore.userData?.family_id || getCookie("famid");
    const clientId = UserStore.userData.user_id || getCookie("userid");
    const assetId = this.selectedAssetClass.id;

    const famData =
      this.famOrClient.name === "fam"
        ? {
            accounttype: "Family",
            isFam: true,
            subUrl: `families/${familyId}`,
          }
        : {
            accounttype: "Client",
            isFam: false,
            subUrl: `Clients/${clientId}`,
          };

    const asset = {
      assetclassid: assetId !== "all" ? assetId : "",
      ...famData,
    };

    try {
      this.performanceData = {
        ...this.performanceData,
        performanceInstumentData: [],
      };
      this.setLoaderStatus("customDataStatus", "pending");
      const response = yield customData({
        fromdate: getDateStrPerformance(this.fromDatePerf),
        todate: getDateStrPerformance(this.toDatePerf),
        ...asset,
      });

      this.monthwiseData = {
        return: response.data?.performanceAssetandAllOverData[0]?.amount,
        as_of_date: getDateStrPerformance(this.toDatePerf),
        xirr: response.data?.performanceAssetandAllOverData[0]?.xirr,
      };
      if (response.data?.performanceSubAssetData?.length) {
        const newArr = toJS(response.data?.performanceSubAssetData)?.map(
          (data) => {
            return {
              instrumentVehicle: {
                name: data?.subAssetClass,
                id: data?.investmentVehicleId,
              },
              absoluteReturn: {
                xirr: data.xirr,
                return: data.amount,
              },
              benchmark: this.dropdownData.xirr,
            };
          }
        );

        const filteredArray = newArr.filter((data) => {
          return (
            Number(Number(data.absoluteReturn.return.actual_value).toFixed()) +
              Number(Number(data.absoluteReturn.xirr).toFixed()) !==
            0
          );
        });
        this.firstPageTable = filteredArray;
      } else this.firstPageTable = [];
      this.performanceData = response.data;
      if (response.status === 200) {
        this.setLoaderStatus("customDataStatus", "success");
      }
      this.loaderCloseFunction();
    } catch (error) {
      this.monthwiseData = {
        return: {
          actual_value: "0.0000000000",
          value: "0.00",
          value_type: "",
        },
        as_of_date: getDateStrPerformance(this.toDatePerf),
        xirr: "0.00",
      };
      this.firstPageTable = [];
      this.performanceData = {};
      this.setLoaderStatus("customDataStatus", "success");
      this.loaderCloseFunction();
    }
  }

  *getCustomBenchMark() {
    try {
      this.setLoaderStatus("customBenchmarkStatus", "pending");
      const response = yield customBenchMark({
        fromdate: getDateStrPerformance(this.fromDatePerf),
        todate: getDateStrPerformance(this.toDatePerf),
        indextypeid: this.selectedIndexForApi,
      });
      this.setApiXirr(response.data?.performanceBenchmark);
      this.setFirstTable();
      if (response.status === 200) {
        this.setLoaderStatus("customBenchmarkStatus", "success");
      }
      this.loaderCloseFunction();
    } catch (error) {
      this.setApiXirr({ xirr: "0" });
      this.setLoaderStatus("customBenchmarkStatus", "success");
      this.loaderCloseFunction();
    }
  }

  getCustomDateData() {
    this.getCustomData();
    this.getCustomBenchMark();
  }

  *submitEventData() {
    try {
      this.setLoaderStatus("submitEvent", "pending");
      const response = yield submitEvents({ eventid: this.selectedEvent?.id });
      if (response.status === 200) {
        this.setLoaderStatus("submitEvent", "success");
      }
    } catch (err) {
      this.loaderCloseOnFail();
    }
  }

  *getEvents(onSuccess, onFail) {
    try {
      this.eventsApiStatus = "loading";
      this.setLoaderStatus("getEventsStatus", "pending");
      const response = yield events();
      if (response.status === 200) {
        this.setLoaderStatus("getEventsStatus", "success");
        this.eventsApiStatus = "success";
      }

      onSuccess && onSuccess(response.data?.performanceEvents);
      this.eventsData = response.data?.performanceEvents;
    } catch (err) {
      onFail && onFail(err);
      this.loaderCloseOnFail();
      this.eventsApiStatus = "success";
    }
  }

  onThirdPage({ assetClassId, subAssetClassId, measureId, folioId }) {
    this.getInstrumentDetails(assetClassId, subAssetClassId, folioId);
    this.getTransaction(measureId, folioId);
  }
  onFirstLoad() {
    if (this.selectedDuration.length < 6) this.handle("getData");
    else {
      this.getCustomDateData();
    }
    if (UserStore.getDataWithNuvamaOrOther !== "");
  }
  onFamCientSelection() {
    this.handle();
    this.getFirstPageData();
  }

  get isHydrated() {
    return isHydrated(this);
  }

  setPerformanceStoreToIntialState() {
    this.filterData = {
      timePeriod: {
        value: "notSelected",
        isSelected: false,
      },
    };
    this.persistedSecPageDuration = "";
    this.selectedEvent = {
      eventName: "Event not selected",
      id: null,
    };
    this.eventsData = [];
    this.performanceData = [];
    this.lastTabName = "CUSTOM";
    this.fromDatePerf = null;
    this.toDatePerf = null;
    this.isAssetClassClicked = false;
    this.timePeriod = {
      value: "notSelected",
      isSelected: true,
    };
    this.fromDateStore = {
      date: "",
      month: "",
      year: "",
    };
    this.toDateStore = {
      date: "",
      month: "",
      year: "",
    };
    this.isFilterApplied = false;
    this.isSecondPagePresent = false;
    this.isDateFilterApplied = false;
    this.currentAppliedFilter = "notSelected";
    this.selectedAssetClass = { id: "all", name: "Overall" };
    this.selectedDuration = "";
    this.selectedIndex = "";
    this.selectedIndexForApi = "";
    this.selectedTransactionsInstrument = {};
    this.indexes = null;
    this.assetClasses = [];
    this.monthwiseData = {};
    this.subTabs = [];
    this.firstPageTable = [];
    this.dropdownData = {};
    this.secondPageTitle = "";
    this.vehicleId = "";
    this.thirdPageTitle = "";
    this.thirdVehicleId = "";
    this.secPageSelectedDuration = "";
    this.status = "ss";
    this.secondPageData = [];
    this.instrumentDetails = {};
    this.instrumentWholeData = { details: null, transaction: null };
    this.derivativeProfile = {};
    this.derivativeDetails = [];
    this.derivativeInstrumentDetails = [];
    this.secPageDerivateId = "";
    this.thirdInstruId = "";
    this.secPageReturnData = {};
    this.famOrClient = { name: "fam", id: "0" };
    this.futureOrOptions = "";
    this.showHoldingDerivatives = "1";
    this.nonDerivativeCheckedStatus = true;
    this.vehicleStatus = "default";
    this.monthDataStatus = "default";
    this.benchmarkStatus = "default";
    this.assteClassStaus = "default";
    this.investmentStatus = "default";
    this.loaderClosingCheck = {};
    this.beforeFilterStatus = "";
    this.dateObj = { from: "", to: "" };
    this.mainTabLoader = false;
    this.inTableLoader = false;
    this.currentLoader = "";
    this.secondPageNormalData = [];
    this.secondPageRememberedNormalData = [];
    this.secondPageDerivativeData = [];
    this.secondPageDerivativeRemberedData = [];
    this.selectedRefs = "";
    this.derivativeRef = "";
    this.selectedFirstRef = "";
    this.mainRef = "";
    this.isSelectedPresent = true;
  }
}

const Performance = new PerformanceStore();

export default Performance;
